<template>
  <div>
    <h2>{{ $t('substitute.title') }}</h2>
    <p>{{ $t('substitute.substitutePlayer') }} {{ substitut.number }} ({{ substitut.gender }}) {{ $t('substitute.with') }}</p>
    <div
        class="radio-group"
    >
      <template

          v-for="player in actives"
          :key="player.id">

        <input
            class="form-check-input"
            type="radio"
            :id="'radioPlayer' + player.id"
            :value="player"
            v-model="selectedPlayer"
            name="playerOptions"
        />
        <label
            class="form-check-label"
            :for="'radioPlayer' + player.id"
        >
          {{ player.number }} ({{ player.gender }})
        </label>
      </template>
    </div>
    <div class="mt-3 d-flex gap-3">
      <button @click="confirmSelection" class="btn btn-bb5-yellow w-100 m-0 p-2 my-2">{{ $t('confirm') }}
      </button>
      <button @click="closeModal" class="btn btn-bb5-black w-100 m-0 p-2 my-2">{{ $t('cancel') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    substitut: Object,
    actives: Array,
  },
  data() {
    return {
      selectedPlayer: null, // To track the selected player
      strickMode: true
    };
  },
  methods: {
    confirmSelection() {
      if (this.selectedPlayer) {
        this.$emit('substitute', this.substitut.id, this.selectedPlayer.id, true );
      } else {
        alert(this.$t('substitute.alert'));
      }
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.radio-group {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 15px;
  margin-top: 20px;
  width: 100%
}

.radio-group label {
  display: inline-block;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  border: 1px solid #000;
  border-radius: 8px;
  background-color: #fff;
  color: #000;
  position: relative;
  transition: all 0.3s ease;
  text-align: center;
  user-select: none;
}

.radio-group input[type="radio"] {
  display: none;
}

.radio-group label::after {
  content: '✓';
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) scale(0);
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  transition: transform 0.2s ease;
}

.radio-group input[type="radio"]:checked + label {
  background-color: var(--bb5-yellow);
  color: #000;
  border-color: var(--bb5-yellow);
}

.radio-group input[type="radio"]:checked + label::after {
  transform: translateY(-50%) scale(1);
}

.radio-group label:hover {
  background-color: #ddd;
  border-color: #aaa;
}
</style>
